import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useAuth } from "../../context/API_Client";
import PaymentCategory from "./PaymentCategory";
import MoreOption from "./MoreOption";
import { keyBy } from "lodash";

const PaymentTab = ({
  disabledOptions,
  updateDisabledOptions,
  disabledPaymentIds,
  updateDisabledPaymentIds,
  numberOfPaymentMethods,
  updateNumberOfPaymentMethods,
  categoryInfo,
}) => {
  return (
    <>
      <Stack spacing={2} sx={{ padding: "0 20px 0 20px" }}>
        {Object.keys(categoryInfo).map((key) => (
          <PaymentCategory
            id={key}
            obj={categoryInfo[key]}
            title={key}
            disabledPaymentIds={disabledPaymentIds}
            updateDisabledPaymentIds={updateDisabledPaymentIds}
            numberOfPaymentMethods={numberOfPaymentMethods}
            updateNumberOfPaymentMethods={updateNumberOfPaymentMethods}
          />
        ))}

        <MoreOption
          disabledOptions={disabledOptions}
          updateDisabledOptions={updateDisabledOptions}
        />
      </Stack>
    </>
  );
};

export default PaymentTab;
